import { ENERGIES_DU_PROFIL } from '@nextilt/commun';
import './ChoixDEnergie.css';

/**
 * L'énergie en semaine, en trois boutons (retour d'Igor au test du chantier profil, 2026-10-21,
 * choix A) : Peu, Moyenne, Beaucoup. Un clic choisit ; un clic sur le bouton déjà choisi le
 * retire. Partagé par la page Profil et le premier formulaire.
 */
export function ChoixDEnergie({
  nom,
  valeur,
  onChoisir,
}: {
  nom: string;
  valeur: string | null;
  onChoisir: (valeur: string) => void;
}) {
  return (
    <span className="choix-d-energie" role="group" aria-label={nom}>
      {ENERGIES_DU_PROFIL.map((energie) => (
        <button
          key={energie}
          type="button"
          aria-pressed={valeur === energie}
          className={valeur === energie ? 'est-choisi' : undefined}
          onClick={() => onChoisir(valeur === energie ? '' : energie)}
        >
          {energie}
        </button>
      ))}
    </span>
  );
}
